import { createAction, props } from '@ngrx/store';
import { IUserBalance, IUser, IUserLogin, ILoginResponse, IVerifyRequest, IVerifyResponse } from '@shared/models';

export enum ActionTypes {
  GetCache                = '[User] Get Cache',
  GetCacheSuccess         = '[User] Get Cache Success',
  Login                   = '[User] Login',
  LoginSuccess            = '[User] Login Success',
  LoginFail               = '[User] Login Fail',
  LoginResponse           = '[User] Login Response',
  Logout                  = '[User] Logout',
  LoadBalance             = '[User] Load Balance',
  LoadBalanceSuccess      = '[User] Load Balance Success',
  UpdateOrganization      = '[User] Update Organization',
  VerifyMfa               = '[User] Verify MFA code',
  VerifyResponse          = '[User] Verify Response',
  Empty                   = '[User] Empty Action',
}

export const getCache = createAction(
  ActionTypes.GetCache
);

export const getCacheSuccess = createAction(
  ActionTypes.GetCacheSuccess,
  props<{ user: IUser }>()
);

export const login = createAction(
  ActionTypes.Login,
  props<{ loginCredentials: IUserLogin }>()
);

export const verifyMfa = createAction(
  ActionTypes.VerifyMfa,
  props<{ verifyRequest: IVerifyRequest }>()
);

export const loginSuccess = createAction(
  ActionTypes.LoginSuccess,
  props<{ user: IUser }>()
);

export const loginFail = createAction(
  ActionTypes.LoginFail,
  props<{ error: string }>()
);

export const loginResponse = createAction(
  ActionTypes.LoginResponse,
  props<{ response: ILoginResponse }>()
);

export const verifyResponse = createAction(
  ActionTypes.VerifyResponse,
  props<{ response: IVerifyResponse }>()
);

export const logout = createAction(
  ActionTypes.Logout
);

export const loadBalance = createAction(
  ActionTypes.LoadBalance
);

export const loadBalanceSuccess = createAction(
  ActionTypes.LoadBalanceSuccess,
  props<{ userBalance: IUserBalance }>()
);

export const updateOrganization = createAction(
  ActionTypes.UpdateOrganization,
  props<{ user: IUser }>()
);

export const emptyAction = createAction(
  ActionTypes.Empty,
  props<{ }>()
);

